"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GET_FEATURED_CONTENT_FOR_GUEST_QUERY = void 0;
const client_1 = require("@apollo/client");
exports.GET_FEATURED_CONTENT_FOR_GUEST_QUERY = (0, client_1.gql) `
  query GetFeaturedContentForGuest {
    featuredContent {
      id
      title
      displayOrder
      featuredItems {
        id
        image {
          url
          accessibilityText
        }
        title
        description
        link {
          text
          type
        }
        entityType
        entityId
        displayOrder
      }
    }
  }
`;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZmVhdHVyZWRDb250ZW50LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vY29tcG9uZW50cy9HdWVzdC9fX3F1ZXJpZXNfXy9mZWF0dXJlZENvbnRlbnQudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBQUEsMkNBQXFDO0FBRXhCLFFBQUEsb0NBQW9DLEdBQUcsSUFBQSxZQUFHLEVBQUE7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztDQXdCdEQsQ0FBQyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IGdxbCB9IGZyb20gXCJAYXBvbGxvL2NsaWVudFwiO1xuXG5leHBvcnQgY29uc3QgR0VUX0ZFQVRVUkVEX0NPTlRFTlRfRk9SX0dVRVNUX1FVRVJZID0gZ3FsYFxuICBxdWVyeSBHZXRGZWF0dXJlZENvbnRlbnRGb3JHdWVzdCB7XG4gICAgZmVhdHVyZWRDb250ZW50IHtcbiAgICAgIGlkXG4gICAgICB0aXRsZVxuICAgICAgZGlzcGxheU9yZGVyXG4gICAgICBmZWF0dXJlZEl0ZW1zIHtcbiAgICAgICAgaWRcbiAgICAgICAgaW1hZ2Uge1xuICAgICAgICAgIHVybFxuICAgICAgICAgIGFjY2Vzc2liaWxpdHlUZXh0XG4gICAgICAgIH1cbiAgICAgICAgdGl0bGVcbiAgICAgICAgZGVzY3JpcHRpb25cbiAgICAgICAgbGluayB7XG4gICAgICAgICAgdGV4dFxuICAgICAgICAgIHR5cGVcbiAgICAgICAgfVxuICAgICAgICBlbnRpdHlUeXBlXG4gICAgICAgIGVudGl0eUlkXG4gICAgICAgIGRpc3BsYXlPcmRlclxuICAgICAgfVxuICAgIH1cbiAgfVxuYDtcbiJdfQ==